// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 模型选择弹窗样式 */

/* 遮罩层 */
.ModelSelectionModal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  opacity: 0;
  transition: opacity 0.2s ease-in-out;
}

.ModelSelectionModal-backdrop.show {
  opacity: 1;
}

/* 弹窗容器 */
.ModelSelectionModal-dialog {
  width: 90%;
  max-width: 800px;
  max-height: 85vh;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
  transform: scale(0.9);
  opacity: 0;
  transition: all 0.2s ease-out;
}

.ModelSelectionModal-dialog.show {
  transform: scale(1);
  opacity: 1;
}

/* 弹窗内容 */
.ModelSelectionModal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 头部 */
.ModelSelectionModal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 24px;
  border-bottom: 1px solid #e0e0e0;
}

.ModelSelectionModal-title {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #333;
}

.ModelSelectionModal-close {
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  color: #666;
  font-size: 18px;
  cursor: pointer;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.ModelSelectionModal-close:hover {
  background: #f5f5f5;
  color: #333;
}

.ModelSelectionModal-close:active {
  transform: scale(0.95);
}

/* 主体内容 */
.ModelSelectionModal-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px;
}

/* 滚动条样式 */
.ModelSelectionModal-body::-webkit-scrollbar {
  width: 8px;
}

.ModelSelectionModal-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.ModelSelectionModal-body::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.ModelSelectionModal-body::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* 模型网格 */
.ModelSelectionModal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 16px;
}

/* 模型卡片 */
.ModelSelectionModal-card {
  padding: 20px;
  border: 2px solid #e0e0e0;
  border-radius: 10px;
  background: white;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  outline: none;
}

.ModelSelectionModal-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);
}

.ModelSelectionModal-card:active {
  transform: translateY(-2px) scale(0.98);
}

.ModelSelectionModal-card:focus-visible {
  outline: 2px solid #0d6efd;
  outline-offset: 2px;
}

/* 图像模型卡片悬停效果 */
.ModelSelectionModal-card-image:hover {
  border-color: #0d6efd;
  box-shadow: 0 6px 16px rgba(13, 110, 253, 0.2);
}

/* 视频模型卡片悬停效果 */
.ModelSelectionModal-card-video:hover {
  border-color: #198754;
  box-shadow: 0 6px 16px rgba(25, 135, 84, 0.2);
}

/* 音频模型卡片悬停效果 */
.ModelSelectionModal-card-audio:hover {
  border-color: #fd7e14;
  box-shadow: 0 6px 16px rgba(253, 126, 20, 0.2);
}

/* 卡片图标 */
.ModelSelectionModal-card-icon {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  margin-bottom: 12px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.03);
}

.ModelSelectionModal-card-icon i {
  display: block;
}

/* 卡片名称 */
.ModelSelectionModal-card-name {
  margin: 0 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

/* 卡片描述 */
.ModelSelectionModal-card-description {
  margin: 0 0 12px 0;
  font-size: 13px;
  color: #666;
  line-height: 1.5;
}

/* 特性标签容器 */
.ModelSelectionModal-card-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

/* 单个特性标签 */
.ModelSelectionModal-card-tag {
  display: inline-block;
  padding: 3px 8px;
  font-size: 11px;
  font-weight: 500;
  border: 1px solid;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
}

/* 底部 */
.ModelSelectionModal-footer {
  padding: 16px 24px;
  border-top: 1px solid #e0e0e0;
  background: #f8f9fa;
  border-radius: 0 0 12px 12px;
}

.ModelSelectionModal-hint {
  margin: 0;
  font-size: 13px;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;
}

.ModelSelectionModal-hint i {
  color: #0d6efd;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .ModelSelectionModal-dialog {
    width: 95%;
    max-height: 90vh;
  }

  .ModelSelectionModal-grid {
    grid-template-columns: 1fr;
  }

  .ModelSelectionModal-header {
    padding: 16px 20px;
  }

  .ModelSelectionModal-body {
    padding: 20px;
  }

  .ModelSelectionModal-title {
    font-size: 18px;
  }
}

@media (min-width: 769px) and (max-width: 1024px) {
  .ModelSelectionModal-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ModelSelectionModal/ModelSelectionModal.css"],"names":[],"mappings":"AAAA,aAAa;;AAEb,QAAQ;AACR;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,qBAAqB;EACrB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA,OAAO;AACP;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,UAAU;AACV;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,SAAS;AACT;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,SAAS;AACT;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,SAAS;AACT;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA,WAAW;AACX;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA,OAAO;AACP;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA,UAAU;AACV;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* 模型选择弹窗样式 */\n\n/* 遮罩层 */\n.ModelSelectionModal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  opacity: 0;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.ModelSelectionModal-backdrop.show {\n  opacity: 1;\n}\n\n/* 弹窗容器 */\n.ModelSelectionModal-dialog {\n  width: 90%;\n  max-width: 800px;\n  max-height: 85vh;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 12px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);\n  transform: scale(0.9);\n  opacity: 0;\n  transition: all 0.2s ease-out;\n}\n\n.ModelSelectionModal-dialog.show {\n  transform: scale(1);\n  opacity: 1;\n}\n\n/* 弹窗内容 */\n.ModelSelectionModal-content {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n}\n\n/* 头部 */\n.ModelSelectionModal-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 20px 24px;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.ModelSelectionModal-title {\n  margin: 0;\n  font-size: 20px;\n  font-weight: 600;\n  color: #333;\n}\n\n.ModelSelectionModal-close {\n  width: 32px;\n  height: 32px;\n  border: none;\n  background: transparent;\n  color: #666;\n  font-size: 18px;\n  cursor: pointer;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n}\n\n.ModelSelectionModal-close:hover {\n  background: #f5f5f5;\n  color: #333;\n}\n\n.ModelSelectionModal-close:active {\n  transform: scale(0.95);\n}\n\n/* 主体内容 */\n.ModelSelectionModal-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n}\n\n/* 滚动条样式 */\n.ModelSelectionModal-body::-webkit-scrollbar {\n  width: 8px;\n}\n\n.ModelSelectionModal-body::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.ModelSelectionModal-body::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 4px;\n}\n\n.ModelSelectionModal-body::-webkit-scrollbar-thumb:hover {\n  background: #a8a8a8;\n}\n\n/* 模型网格 */\n.ModelSelectionModal-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 16px;\n}\n\n/* 模型卡片 */\n.ModelSelectionModal-card {\n  padding: 20px;\n  border: 2px solid #e0e0e0;\n  border-radius: 10px;\n  background: white;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  position: relative;\n  outline: none;\n}\n\n.ModelSelectionModal-card:hover {\n  transform: translateY(-4px);\n  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.12);\n}\n\n.ModelSelectionModal-card:active {\n  transform: translateY(-2px) scale(0.98);\n}\n\n.ModelSelectionModal-card:focus-visible {\n  outline: 2px solid #0d6efd;\n  outline-offset: 2px;\n}\n\n/* 图像模型卡片悬停效果 */\n.ModelSelectionModal-card-image:hover {\n  border-color: #0d6efd;\n  box-shadow: 0 6px 16px rgba(13, 110, 253, 0.2);\n}\n\n/* 视频模型卡片悬停效果 */\n.ModelSelectionModal-card-video:hover {\n  border-color: #198754;\n  box-shadow: 0 6px 16px rgba(25, 135, 84, 0.2);\n}\n\n/* 音频模型卡片悬停效果 */\n.ModelSelectionModal-card-audio:hover {\n  border-color: #fd7e14;\n  box-shadow: 0 6px 16px rgba(253, 126, 20, 0.2);\n}\n\n/* 卡片图标 */\n.ModelSelectionModal-card-icon {\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 24px;\n  margin-bottom: 12px;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.ModelSelectionModal-card-icon i {\n  display: block;\n}\n\n/* 卡片名称 */\n.ModelSelectionModal-card-name {\n  margin: 0 0 8px 0;\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n}\n\n/* 卡片描述 */\n.ModelSelectionModal-card-description {\n  margin: 0 0 12px 0;\n  font-size: 13px;\n  color: #666;\n  line-height: 1.5;\n}\n\n/* 特性标签容器 */\n.ModelSelectionModal-card-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n/* 单个特性标签 */\n.ModelSelectionModal-card-tag {\n  display: inline-block;\n  padding: 3px 8px;\n  font-size: 11px;\n  font-weight: 500;\n  border: 1px solid;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.8);\n  white-space: nowrap;\n}\n\n/* 底部 */\n.ModelSelectionModal-footer {\n  padding: 16px 24px;\n  border-top: 1px solid #e0e0e0;\n  background: #f8f9fa;\n  border-radius: 0 0 12px 12px;\n}\n\n.ModelSelectionModal-hint {\n  margin: 0;\n  font-size: 13px;\n  color: #666;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ModelSelectionModal-hint i {\n  color: #0d6efd;\n}\n\n/* 响应式设计 */\n@media (max-width: 768px) {\n  .ModelSelectionModal-dialog {\n    width: 95%;\n    max-height: 90vh;\n  }\n\n  .ModelSelectionModal-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .ModelSelectionModal-header {\n    padding: 16px 20px;\n  }\n\n  .ModelSelectionModal-body {\n    padding: 20px;\n  }\n\n  .ModelSelectionModal-title {\n    font-size: 18px;\n  }\n}\n\n@media (min-width: 769px) and (max-width: 1024px) {\n  .ModelSelectionModal-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
